module.exports = __webpack_public_path__ + "static/media/background_4.1c016195.png";